"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCheckoutLinkForCampaignDto = void 0;
class CreateCheckoutLinkForCampaignDto {
    summary;
    campaignReqId;
    campaignName;
    displayNames;
}
exports.CreateCheckoutLinkForCampaignDto = CreateCheckoutLinkForCampaignDto;
